<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Localização GPS">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/4 mb-base">
          <button
            name="button"
            class="vs-component vs-button vs-button-warning vs-button-relief"
            :disabled="processing"
            @click="updateLocation()"
          >
            <span class="vs-button-text vs-button--text">
              <i class="fas fa-location-arrow"></i> Capturar Localização Atual
            </span>
            <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%)"></span>
          </button>
        </div>
        <div class="vx-col w-full lg:w-1/4 mb-base">
          <MobileSalvarDados :dispositivo="dispositivo" relationship="location" :pagination="meta.pagination"/>
        </div>
        <div class="vx-col w-full lg:w-2/4 mb-base">
          <div class="con-vs-alert con-vs-alert-primary">
            <div class="vs-alert text-center">
              Este recurso só funciona se o celular estiver online com uma conexão estável e o GPS ativo.
            </div>
          </div>
        </div>
      </div>
      <div class="mb-2">
        <vs-table
          ref="table"
          :data="data"
          noDataText="Nenhum item encontrado no período selecionado"
          class="mt-4 pagination"
        >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12"></vs-col>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
                <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
                  <vs-pagination :total="meta.pagination.total_pages" v-model="page" :max="5"></vs-pagination>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-table>
      </div>

      <div class="vx-row block sm:hidden">
        <div class="vx-col w-full lg:w-1/2 mb-base">
          <l-map :zoom="map.zoom" :center="map.center" style="height: 240px; z-index: 0">
            <l-tile-layer :url="map.url" :attribution="map.attribution" />
            <l-marker :lat-lng="m.pointer" v-for="m in map.markers" :key="m.id">
              <l-tooltip>{{ m.dateTime | formatDateTime }}</l-tooltip>
            </l-marker>
          </l-map>

          <div v-show="dispositivo.uid && dispositivo.licence.until === null" class="w-full mt-6">
            <div class="vx-col w-full h-full prc-2 mb-base">
              <vx-card slot="no-body" class="text-center h-full bg-primary-gradient greet-user">
                <feather-icon
                  icon="AwardIcon"
                  class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                  svgClasses="h-8 w-8"
                ></feather-icon>
                <h1 class="mb-6 text-white">Aviso Importante</h1>
                <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                  O restante do conteúdo foi bloqueado por sua conta estar na
                  <strong>Versão Gratuita</strong> desbloqueie o conteúdo agora mesmo.
                </p>
                <br />
                <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                  <vs-button color="warning" type="relief">
                    <vs-icon icon-pack="fas" icon="fa-shopping-cart"></vs-icon>&nbsp;Liberar Conteúdo Completo
                  </vs-button>
                </router-link>
              </vx-card>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2 mb-base">
          <vs-table ref="table" :data="data" noDataText="Nenhum item encontrado no período selecionado" class="data">
            <template slot="thead">
              <vs-th sort-key="date">DATA</vs-th>
              <vs-th sort-key="longitude" class="text-center">GOOGLE MAPS</vs-th>
              <vs-th sort-key="latitude">WIFI</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-show="locationLoading">
                <vs-td colspan="3">
                  <div class="container">
                    <div id="loading" class="vs-con-loading__container"></div>
                  </div>
                </vs-td>
              </vs-tr>

              <vs-tr :key="index" v-for="(linha, index) in data">
                <vs-td class="text-nowrap">
                  <span @click="setLocation(data[index])">({{ index + 1 }}) {{ data[index].datetime | formatDateTime }}</span>
                </vs-td>
                <vs-td class="text-center">
                  <span>
                    <a
                      :href="'https://www.google.com/maps/search/?api=1&query=' + data[index].latitude + '%2C' + data[index].longitude"
                      target="_blank"
                    >
                      <i class="fas fa-map-marked-alt fa-2x"></i>
                    </a>
                  </span>
                </vs-td>
                <vs-td>
                  <span @click="setLocation(data[index])">{{ data[index].wifi_ssid }}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="vx-col w-full lg:w-1/2 mb-base hidden sm:block">
          <div v-show="dispositivo.uid && dispositivo.licence.until === null" class="w-full">
            <div class="vx-col w-full h-full prc-2 mb-base">
              <vx-card slot="no-body" class="text-center h-full bg-primary-gradient greet-user">
                <feather-icon
                  icon="AwardIcon"
                  class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                  svgClasses="h-8 w-8"
                ></feather-icon>
                <h1 class="mb-6 text-white">Aviso Importante</h1>
                <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                  O restante do conteúdo foi bloqueado por sua conta estar na
                  <strong>Versão Gratuita</strong> desbloqueie o conteúdo agora mesmo.
                </p>
                <br />
                <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                  <vs-button color="warning" type="relief">
                    <vs-icon icon-pack="fas" icon="fa-shopping-cart"></vs-icon>&nbsp;Liberar Conteúdo Completo
                  </vs-button>
                </router-link>
              </vx-card>
            </div>
          </div>

          <l-map :zoom="map.zoom" :center="map.center" style="height: 520px; z-index: 0">
            <l-tile-layer :url="map.url" :attribution="map.attribution" />
            <l-marker :lat-lng="m.pointer" v-for="m in map.markers" :key="m.id">
              <l-tooltip>{{ m.dateTime | formatDateTime }}</l-tooltip>
            </l-marker>
          </l-map>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import L from 'leaflet';

export default {
  data() {
    return {
      processing: false,
      data: [],
      locationLoading: true,
      dispositivo: {
        licence: {
          until: null,
        },
      },
      meta: {
        pagination: {
          total_pages: 0,
        },
      },
      page: 1,
      dateFilterId: 5,
      dateFilterText: 'Todos os Registros',
      map: {
        zoom: 16,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '',
        center: L.latLng(0, 0),
        currentCenter: L.latLng(0, 0),
        currentZoom: 16,
        markers: [],
        polyline: {
          latlngs: [],
          color: '#7265EF',
        },
      },
    };
  },

  watch: {
    page: function () {
      this.load();
    },
  },

  mounted() {
    this.load();

    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1,
    });
  },

  methods: {
    updateLocation() {
      this.processing = true;
      this.$api.get('/api/v1/mobile/location/' + this.$localStorage.get('uid') + '/update').then((response) => {
        this.processing = false;

        if (!response.data.error) {
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso',
            text: 'Comando enviado com sucesso. Aguarde alguns minutos para que a localização seja mostrada.',
          });

          setTimeout(() => {
            this.load();
          }, 15000);
        } else if (parseInt(response.data.code) == 1) {
          this.$vs.notify({
            color: 'danger',
            title: 'Aviso',
            text:
              'Desculpe, este recurso permite apenas 1 uso para aparelhos em modo teste.<br>' +
              'Adquira sua licença para desbloquear esta função.',
          });
        } else if (parseInt(response.data.code) == 2) {
          this.$vs.notify({
            color: 'danger',
            title: 'Aviso',
            text:
              'Você só pode requisitar uma atualização a cada 5 minutos.<br>' +
              'Por favor, tente novamente em alguns minutos.',
          });
        }
      });
    },
    setLocation(location) {
      let latLng = L.latLng(location.latitude, location.longitude);
      this.map.center = latLng;
      this.map.currentCenter = latLng;
      this.map.activeMarker = location;
    },
    load: function () {
      const mobile = JSON.parse(this.$localStorage.get('mobile'));
      this.$api
        .get(
          `/api/v${mobile.panel_version}/mobile/location/${mobile.uid}?page=${this.page}&dateFilterId=${this.dateFilterId}`
        )
        .then((response) => {
          this.locationLoading = false;
          this.data = response.data.data;
          this.meta = response.data.meta || { pagination: { total_pages: 0 } };

          this.map.markers = [];
          this.map.polyline.latlngs = [];

          if (this.data.length) {
            var i = this.data[0];
            this.setLocation(i);

            this.data.forEach((i, idx) => {
              this.map.markers.push({
                address: i.address,
                dateTime: i.datetime,
                pointer: L.latLng(i.latitude, i.longitude),
                icon: L.divIcon({ className: 'map-marker', html: idx + 1 }),
              });

              this.map.polyline.latlngs.push([i.latitude, i.longitude]);
            });
          }
        });

      this.$api.get(`/api/v${mobile.panel_version}/mobile/device/${mobile.uid}`).then((response) => {
        this.dispositivo = response.data.data;
        this.$EventBus.$emit('deviceChanged', this.dispositivo);
      });
    },
    setDateFilter: function (filterId) {
      this.dateFilterId = filterId;
      this.load();

      switch (this.dateFilterId) {
        case 0:
          this.dateFilterText = 'Hoje';
          break;
        case 1:
          this.dateFilterText = 'Ontem';
          break;
        case 2:
          this.dateFilterText = 'Últimos 7 dias';
          break;
        case 3:
          this.dateFilterText = 'Últimos 30 dias';
          break;
        case 4:
          this.dateFilterText = 'Últimos 90 dias';
          break;
        case 5:
          this.dateFilterText = 'Todos os Registros';
          break;
      }
    },
  },
};
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    @media (max-width: 576px) {
      .vs-table--header {
        margin-left: 0.6rem;
        margin-right: 0.6rem;
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.map-marker {
  width: 30px !important;
  height: 30px !important;
  background: rgba(var(--vs-primary), 1);
  color: #fff;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  box-shadow: 0px 0px 4px 0px rgba(var(--vs-primary), 1);
}

.td.vs-table--td span {
  cursor: pointer;
}
.pagination .vs-table--content {
  display: none;
}

.data {
  height: 100%;
  overflow: auto;
}

#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
